import { useLayoutEffect, useState } from 'react';

type Observable={getState():unknown;subscribe(listener:()=>void):()=>void};
/** The retained workspace owns disposal. Route/Focus views only subscribe. */
export function useResourceBoardSession<Session extends Observable>(session:Session|null) {
  const read=()=>session?.getState() as ReturnType<Session['getState']>|undefined;
  const [snapshot,setSnapshot]=useState(()=>({session,value:read()??null}));
  useLayoutEffect(()=>{
    const update=()=>setSnapshot({session,value:read()??null});
    update();return session?.subscribe(update);
  },[session]);
  return snapshot.session===session ? snapshot.value : read()??null;
}
